import React from 'react';
import Footer from './components/Footer'
import MaskAnimation from './components/MaskAnimation';
import InViewComponent from './components/InView';
import AnimateIn from './components/AnimateIn';
import { useEffect, useState } from 'react';
import '../App.css'
import { useRef } from 'react';
import { useLang } from '../hook/UseLang';
import CONTENT from '../contents/faq'

const Faq = () => {
    const [lang, setLang] = useLang()
    const text1Ref = useRef()
    const [DATA, setData1] = useState([])
    const [DATA_2, setData2] = useState([])
    useEffect(() => {
        const DATA = [
            {
                q:CONTENT.q1[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q1_a[lang]}</div>
                    <a href={`https://book-directonline.com/properties/twentyonewhitfield`} target='_blank' className='text-[#0FBAB5]'>https://book-directonline.com/properties/twentyonewhitfield</a>
                </div>)
            },
            {
                q:CONTENT.q2[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q2_a[lang]}</div>
                </div>)
            },
            // {
            //     q:CONTENT.q3[lang],
            //     a:(<div className='flex flex-col' style={{gap:12}}>
            //         <div style={{whiteSpace:'pre-wrap'}}>{CONTENT.q3_a[lang]}</div>
            //     </div>)
            // },
        ]
        setData1(DATA)
        const DATA_2 = [
            {
                q:CONTENT.q4[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q4_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q5[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q5_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q6[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q6_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q7[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q7_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q8[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q8_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q9[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q9_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q10[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q10_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q11[lang],
                a:(<div className='flex flex-col' style={{gap:12}}>
                    <div>{CONTENT.q11_a[lang]}</div>
                </div>)
            },
        ]
        setData2(DATA_2)
    },[lang])
    return (
        <div className='w-full text-d-12 addnavpadding flex flex-col items-center noto-sans-hk'>
            <div className='relative w-full h-[15vh]'>
                <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                <div ref={text1Ref} className='relative w-full h-full w-full flex flex-row items-center justify-center playfair-display font-bold text-d-35 title_text'>{CONTENT.faq[lang]}</div>
                <InViewComponent reffing={text1Ref} active='title_text_active' delay={2000} />
            </div>
            <div className='w-full max-w-[650px] mt-[71px] flex flex-col items-center justify-start x-padding'>
                <div className='w-[90%] py-[12px] bg-[#9B998F] rounded-full text-white text-center font-[600px]'>{CONTENT.aboutThis[lang]}</div>
                {DATA.map((obj , i) => (
                    <AnimateIn className='w-full' once={true}>
                        <div className={'w-full pb-[66px] mt-[49px] ' + (i !== DATA.length - 1 ? 'border-b border-b-[1px] border-b-[#0FBAB5]' : '')}>
                            <div className='w-full flex flex-row items-center justify-start'>
                                <div className='text-[20px] font-bold mr-[27px]'>Q</div>
                                <div>{obj.q}</div>
                            </div>
                            <div className='w-full flex flex-row items-start justify-start mt-[26px]'>
                                <div className='text-[20px] font-bold mr-[27px] line-height-0 text-[#0FBAB5] pl-[1px]' style={{display:'inline-block', lineHeight:1}}>A</div>
                                {obj.a}
                            </div>
                        </div>
                    </AnimateIn>
                ))}
                <div className='w-[90%] py-[12px] mt-[36px] bg-[#9B998F] rounded-full text-white text-center font-[600px]'>{CONTENT.aboutServices[lang]}</div>
                {DATA_2.map((obj , i) => (
                    <AnimateIn className='w-full' once={true}>
                        <div className={'w-full pb-[66px] mt-[49px] ' + (i !== DATA_2.length - 1 ? 'border-b border-b-[1px] border-b-[#0FBAB5]' : '')}>
                            <div className='w-full flex flex-row items-center justify-start'>
                                <div className='text-[20px] font-bold mr-[27px]'>Q</div>
                                <div>{obj.q}</div>
                            </div>
                            <div className='w-full flex flex-row items-start justify-start mt-[26px]'>
                                <div className='text-[20px] font-bold mr-[27px] line-height-0 text-[#0FBAB5] pl-[1px]' style={{display:'inline-block', lineHeight:1}}>A</div>
                                {obj.a}
                            </div>
                        </div>
                    </AnimateIn>
                ))}
            </div>
            <Footer />
            <MaskAnimation />
        </div>
    );
};

export default Faq;